import React from 'react';
import { BsPlusCircle } from 'react-icons/bs';
import { MdRefresh } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import SearchFilters from '../../../../../../../../../components/search/SearchFIlters';
import SearchGlobalSearchInput from '../../../../../../../../../components/search/SearchGlobalSearchInput';
import { analyticsIds } from '../../../../../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../constants/duskIds';
import {
  activitySearch,
  openAddComment,
  selectAddingComment
} from '../../../../../../../../../redux/modules/activityLog';
import { closeOpenedQuickFilterInputs } from '../../../../../../../../../utils/quickFiltersUtil';
import ActivityLogTypeFilters from '../ActivityLogTypeFilters';

const ActivityLogHeader = ({ insuredId, recordId }) => {
  const dispatch = useDispatch();
  const addingComment = useSelector(selectAddingComment);
  const isLoading = useSelector(activitySearch.selectIsLoading);
  const quickFilters = useSelector(activitySearch.selectQuickFilterOptions);

  return (
    <Box mx={6}>
      <Flex alignItems="flex-end" justifyContent="space-between">
        <HStack mt={2} pb={2} pt={4} spacing={2}>
          <Text textStyle="bodyLg600">User Activity Log</Text>
          <SearchFilters
            dataAnalyticsId={analyticsIds.insuredProfilePage.activityLog.openFilterModal}
            popoverPlacement="right"
            searchBlueprint={activitySearch}
            variant="textBlack"
            onPopoverClose={() => closeOpenedQuickFilterInputs(quickFilters)}
          />
          <IconButton
            aria-label="Refresh Activity Log"
            data-analytics-id={analyticsIds.insuredProfilePage.activityLog.refreshActivityLogButton}
            data-cy={CypressIds.activityLogRefreshButton}
            dusk={InsuredProfilePageDuskIds.refreshActivityLogButton}
            icon={<Icon as={MdRefresh} h={6} w={6} />}
            variant="textBlack"
            onClick={() => dispatch(activitySearch.getPage())}
          />
        </HStack>
        <SearchGlobalSearchInput
          dataAnalyticsId={analyticsIds.insuredProfilePage.activityLog.searchActivityLogInput}
          ml="auto"
          pb={2}
          searchBlueprint={activitySearch}
        />
      </Flex>
      <Flex
        dusk={isLoading ? InsuredProfilePageDuskIds.activityLogLoading : InsuredProfilePageDuskIds.activityLogLoaded}
        justifyContent="space-between"
        mb={6}
      >
        <ActivityLogTypeFilters insuredId={insuredId} recordId={recordId} />
        { isLoading && (<Text color="greyScale.800">Loading...</Text>)}
        <Button
          data-analytics-id={analyticsIds.insuredProfilePage.activityLog.createCommentButton}
          leftIcon={<Icon as={BsPlusCircle} />}
          size="sm"
          variant="textPrimary"
          onClick={() => (addingComment ? '' : dispatch(openAddComment()))}
        >
          Create Comment
        </Button>
      </Flex>
    </Box>
  );
};

ActivityLogHeader.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired
};

export default ActivityLogHeader;
